export const TOURNAMENTS_LIST_REQUEST = 'TOURNAMENTS_LIST_REQUEST';
export const TOURNAMENTS_LIST_SUCCESS = 'TOURNAMENTS_LIST_SUCCESS';
export const TOURNAMENTS_MY_RANK_REQUEST = 'TOURNAMENTS_MY_RANK_REQUEST';
export const TOURNAMENTS_MY_RANK_SUCCESS = 'TOURNAMENTS_MY_RANK_SUCCESS';
export const TOURNAMENTS_RANKS_REQUEST = 'TOURNAMENT_RANKS_REQUESTS';
